import dayjs from '@/plugins/Dayjs'

export function timeToMinutes (t) {
  if (!t) return 0

  const [h, m] = t.trim().padStart(5, '0').split(':').map(Number)

  if (Number.isNaN(h) || Number.isNaN(m)) return 0

  return h * 60 + m
}

export function sortByTime (arr, key) {
  return arr.sort((a, b) => timeToMinutes(a[key]) - timeToMinutes(b[key]))
}

export function sortByTimeFn (arr, getTime) {
  return [...arr].sort((a, b) => timeToMinutes(getTime(a)) - timeToMinutes(getTime(b)))
}

export function sortByDate (arr, key = 'date') {
  return [...arr].sort((a, b) => dayjs(a[key]).valueOf() - dayjs(b[key]).valueOf())
}
